import { useId, type ReactNode } from 'react';
import { CircleAlert } from 'lucide-react';

import { cn } from '../lib/utils';
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from './Empty';

export interface PortalErrorPageProps extends React.ComponentProps<'main'> {
  actions: ReactNode;
  brand: string;
  description: string;
  status: 'error' | 'not-found';
  title: string;
}

export function PortalErrorPage({
  actions,
  brand,
  className,
  description,
  status,
  title,
  ...props
}: PortalErrorPageProps) {
  const titleId = useId();
  const descriptionId = useId();

  return (
    <main
      aria-describedby={descriptionId}
      aria-labelledby={titleId}
      className={cn('flex min-h-dvh items-center justify-center px-4 py-10', className)}
      {...props}
    >
      <Empty className="max-w-lg border-0">
        <EmptyHeader>
          <p className="text-xs font-medium text-muted-foreground">{brand}</p>
          <EmptyMedia variant={status === 'error' ? 'icon' : 'default'}>
            {status === 'error' ? (
              <CircleAlert aria-hidden="true" />
            ) : (
              <span className="text-3xl font-semibold text-foreground">404</span>
            )}
          </EmptyMedia>
          <EmptyTitle id={titleId}>{title}</EmptyTitle>
          <EmptyDescription id={descriptionId}>{description}</EmptyDescription>
        </EmptyHeader>
        <EmptyContent>{actions}</EmptyContent>
      </Empty>
    </main>
  );
}
